import { PdfContext } from 'utils/context';
import CoverPage from './Pages/CoverPage';
import './pdfComponent.style.scss';
import ParcelSynthesis from './Pages/ParcelSynthesis';
import GenericGraphPage from './Pages/GenericGraphPage';
import KeyNumberPage from './Pages/KeyNumberPage';
import CapPoints from './Pages/CapPoints';
import Constraint from './Pages/Constraint';
import ObligationRestriction from './Pages/ObligationRestriction';
import GraphPerYearPage from './Pages/GraphPerYear';
import CultureListConventional from './Pages/CultureListConventional';
import KeyNumberNitrogenPage from './Pages/KeyNumberNitrogenPage';
import CultureListOrganic from './Pages/CultureListOrganic';
import Tonnage from './Pages/Tonnage';
import { useTranslation } from 'react-i18next';

const PdfComponent = ({ data, results, totalFooterMargin }) => {
  const { t } = useTranslation();
  const {
    proposal,
    constraints,
    pac,
    obligationRestrictions,
    isNitrogenASelectedConstraint,
    isExtraBiomassASelectedConstraint,
    invertedCultures,
    forecastCampaign,
  } = data;

  const root = document.documentElement;
  root.style.setProperty('--height-pdf', `calc(21cm - ${totalFooterMargin}px)`);
  root.style.setProperty('--margin-bottom-pdf', `${totalFooterMargin}px`);

  const result = Object.entries(results.suggestions).find(([key, _]) => key === proposal);
  // const suggest = result[1];
  // data = { ...data, suggest };
  const hasIntercrops = !!results.cultures.find((cult) => cult.type === 'intermediate');

  const hasConstraints =
    constraints.typeCoProduit.length > 0 || constraints.autres.length > 0 || constraints?.pac;
  const hasPacTable = pac.length > 0;
  const hasObligationRestriction = obligationRestrictions.length > 0;
  const hasInvertedCultures = invertedCultures.length > 0;

  return (
    <PdfContext.Provider value={data}>
      <CoverPage />
      {result && (
        <div>
          <ParcelSynthesis
            isNitrogenASelectedConstraint={isNitrogenASelectedConstraint}
            isExtraBiomassASelectedConstraint={isExtraBiomassASelectedConstraint}
            forecastCampaign={forecastCampaign}
          />
          <GenericGraphPage
            dataKey="graphMarge"
            title={t('simulation.result.pdf.graphs.grossMarginEvolution')}
          />
          <KeyNumberPage />
          {isNitrogenASelectedConstraint && <KeyNumberNitrogenPage />}
          {hasPacTable && <CapPoints />}

          {/* GRAPH CULTURE DONUT THEN STACKED */}
          <GraphPerYearPage dataKey="graphPerYear" />
          <GenericGraphPage
            img={data.stackedCharts?.cultures?.euros}
            title={t('simulation.result.pdf.graphs.culturesEvolutionEur')}
          />
          <GenericGraphPage
            img={data.stackedCharts?.cultures?.ha}
            title={t('simulation.result.pdf.graphs.culturesEvolutionHa')}
          />

          {/* GRAPH INTERCULTURE DONUT THEN STACKED */}
          {hasIntercrops && (
            <div>
              <GraphPerYearPage dataKey="graphInterculturePerYear" hidePrevious={true} />
              <GenericGraphPage
                img={data.stackedCharts?.intercultures?.euros}
                title={t('simulation.result.pdf.graphs.interculturesEvolutionEur')}
              />
              <GenericGraphPage
                img={data.stackedCharts?.intercultures?.ha}
                title={t('simulation.result.pdf.graphs.interculturesEvolutionHa')}
              />
            </div>
          )}

          <Tonnage />

          {hasObligationRestriction && <ObligationRestriction />}
          {hasConstraints && <Constraint />}
          <CultureListConventional />
          {hasInvertedCultures && <CultureListOrganic />}
        </div>
      )}
    </PdfContext.Provider>
  );
};

export default PdfComponent;
